<template>
  <div class="appletWesternInput">
    <Select
      v-model="appletWesternCode"
      clearable
      filterable
      :placeholder="placeholder"
      @on-query-change="onQueryChange"
      @on-change="onChange"
    >
      <Option
        v-for="item in diseaseNames"
        :value="item.value"
        :key="item.value"
        :label="item.label"
        >{{ item.labelAndPy }}
      </Option>
    </Select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请点击输入诊断拼音首字母",
    },
  },
  computed: {
    text() {
      return this.common.valueToLabel(diseaseNames, this.value);
    },
  },
  data() {
    return {
      diseaseNames: [],
      appletWesternCode: this.value,
    };
  },
  watch: {
    value(val) {
      this.init();
    },
  },
  methods: {
    onQueryChange(query) {
      if (query != "" && query.length) {
        this.diseaseNames = diseaseNames.filter((item) => {
          return item.labelAndPy.indexOf(query.toUpperCase()) > -1;
        });
      } else {
        this.diseaseNames = [];
      }
    },
    onChange() {
      this.$emit("input", this.appletWesternCode);
    },
    init() {
      this.diseaseNames = diseaseNames.filter(
        (item) => item.value == this.value
      );
      this.appletWesternCode = this.value;
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.appletWesternInput {
  .text {
    .t2 {
      color: #ccc;
    }
  }
}
</style>